module.exports = __webpack_public_path__ + "img/i-attributes-admin.8034c754.svg";